import React, { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
import { Input } from "../ui/input";

const URL = "https://data.geopf.fr/geocodage/search";

export default function AddressAutocomplete({ value, onChange, onPick, placeholder, className }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const skip = useRef(false);

  useEffect(() => {
    if (skip.current) { skip.current = false; return; }
    const q = value.trim();
    if (q.length < 3) { setItems([]); return; }
    const ctrl = new AbortController();
    const t = setTimeout(() => {
      fetch(`${URL}?q=${encodeURIComponent(q)}&autocomplete=1&limit=6&lat=48.57&lon=-1.75`, { signal: ctrl.signal })
        .then((r) => r.json()).then((d) => { setItems(d.features || []); setOpen(true); setActive(-1); }).catch(() => {});
    }, 250);
    return () => { clearTimeout(t); ctrl.abort(); };
  }, [value]);

  const pick = (f) => {
    const p = f.properties;
    skip.current = true;
    onChange(p.type === "municipality" ? "" : p.name);
    onPick?.({ city: p.city, postcode: p.postcode, label: p.label });
    setOpen(false);
  };
  const onKey = (e) => {
    if (!open || !items.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((a) => Math.min(a + 1, items.length - 1)); }
    if (e.key === "ArrowUp") { e.preventDefault(); setActive((a) => Math.max(a - 1, 0)); }
    if (e.key === "Enter" && active >= 0) { e.preventDefault(); pick(items[active]); }
    if (e.key === "Escape") setOpen(false);
  };

  return (
    <div className="relative">
      <Input value={value} onChange={(e) => onChange(e.target.value)} onKeyDown={onKey} onFocus={() => items.length && setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder} className={className} autoComplete="off" role="combobox" aria-expanded={open} data-testid="prop-address" />
      {open && items.length > 0 && (
        <ul className="absolute z-30 left-0 right-0 mt-2 rounded-2xl bg-white ring-1 ring-[#e6dcc8] shadow-[0_25px_50px_-20px_rgba(19,38,28,0.4)] overflow-hidden" role="listbox" data-testid="address-suggestions">
          {items.map((f, i) => (
            <li key={f.properties.id || i} role="option" aria-selected={i === active}>
              <button type="button" onMouseDown={(e) => { e.preventDefault(); pick(f); }} data-testid={`address-option-${i}`}
                className={`w-full flex items-start gap-3 px-4 py-3 text-left transition-colors ${i === active ? "bg-[#f1ebdd]" : "hover:bg-[#f6f1e7]"}`}>
                <MapPin className="w-4 h-4 mt-0.5 text-[#c4703f] shrink-0" />
                <span><span className="block font-semibold text-[#13261c]">{f.properties.name}</span><span className="text-sm text-[#6d7268]">{f.properties.postcode} {f.properties.city}</span></span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
